import { Customer } from './customer';
import { Role } from '../enums';
import { Partner } from './partner';

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  customer: Customer | null;
  partner: Partner | null;
  active: boolean;
  role: Role;
  note: string | null;
}

export namespace User {
  export function mapFromApiValue({ role, ...restOfUser }: any): User {
    return {
      ...restOfUser,
      role: Role.mapFromApiValue(role),
    };
  }
}
